import NavBar from "../components/NavBar";
import Footer from "../components/Footer";

function DigitalFiles(){

    return(
        <div>
            <NavBar/>
            <main>
                <div>
                    <h1>Send Digital Files</h1>
                </div>
                <div>
                    <h2>How to Send Digital Files</h2>
                    <p>We proudly accept scans from  iTero, Cerec, 3Shape, and .STL files from others.</p>
                </div>
                <div className='grid'>
                    
                    <div>
                        <img src='/img/itero.png' className='scan-img'/>
                        <h3>To send a scan with iTero:</h3>
                        <ul>
                            <li>Call customer support: 1-800-577-8767</li>
                            <li>Ask to add Company ID: 143407 Osseo Dental to your scanner</li>
                        </ul>
                    </div>
                    <div>
                        <img src='/img/3shape.png' className='scan-img'/>
                        <h3>To send a scan with 3Shape:</h3>
                        <ul>
                            <li>Open 3Shape Communicate from Trios</li>
                            <li>Login</li>
                            <li>Click 'Connections'</li>
                            <li>Click 'Add Connections'</li>
                            <li>Search osseodentpro@gmail.com</li>
                            <li>Click our Lab and press Connect</li>
                        </ul>
                    </div>
                    <div>
                        <img src='/img/cerec.png' className='scan-img'/>
                        <h3>To send a scan with Cerec:</h3>
                        <ul>
                            <li>Search for osseodentpro.com on your D.S. core</li>
                            <li>Select Osseo Dental Prosthetics</li>
                            <li>Submit</li>
                        </ul>
                    </div>
                    <div>
                        <img src='/img/stl.png' className='scan-img'/>
                        <h3>For sending an .STL file outside your software system</h3>
                        <ul>
                            <li>Call us to let us know you are sending it</li>
                            <li>Email it to osseodentpro@gmail.com</li>
                        </ul>
                    </div>
                </div>
                
            </main>
            <Footer/>
        </div>
    )
}
export default DigitalFiles;